import { render, staticRenderFns } from "./relationNew.vue?vue&type=template&id=feea0972&scoped=true"
import script from "./relationNew.vue?vue&type=script&lang=js"
export * from "./relationNew.vue?vue&type=script&lang=js"
import style0 from "./relationNew.vue?vue&type=style&index=0&id=feea0972&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feea0972",
  null
  
)

export default component.exports